import React, { useEffect, useState } from 'react';

import { getEntries } from '../../../../api/accessEntry';
import {
	Card,
	CardBody,
	CardHeader,
} from '../../../../_metronic/_partials/controls';
import Table, { dateFormatter } from '../../../components/tables/table';
import { alertError } from '../../../../utils/logger';

const getData = (entries) =>
	entries.map((entry) => ({
		...entry,
		provider: entry.provider || '---',
		user: entry.user?.fullName || entry.guest?._id || '---',
	}));

export function AccessEntriesPage() {
	const [data, setData] = useState([]);
	const [refresh, setRefresh] = useState(false);

	const columns = [
		{
			dataField: 'timestamp',
			text: 'Timestamp',
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: 'type', text: 'Type', sort: true },
		{ dataField: 'user', text: 'User', sort: true },
		{ dataField: 'provider', text: 'Provider', sort: true },
	];

	useEffect(() => {
		getEntries()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) =>
				alertError({
					error: error,
					customMessage: 'Could not get entries.',
				})
			);
	}, [refresh]);

	return (
		<Card>
			<CardHeader title={'Access Logs'} />
			<CardBody>
				<Table data={data} columns={columns} />
			</CardBody>
		</Card>
	);
}
